module.exports = __webpack_public_path__ + "img/list9.e69c6b55.png";